<div #chartdiv [id]="id_chart" class="chartdiv" [style.width]="width" [style.maxwidth]="width"></div>

